import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"keyframe, rhombus"} maskId="square-filled-radius-0-stroke-1-IconKeyframe"><path d="M12.0001 1.29297L1.29297 12L12.0001 22.7072L22.7072 12L12.0001 1.29297Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconKeyframe;
